
import ShoppingCart from '../mixins/shopping-cart'

export default {
  inheritAttrs: false,
  mixins: [ShoppingCart],
  props: {
    tag: {
      type: String,
      default: 'vs-button'
    },
    product: {
      type: Object,
      default: () => {}
    },
    variantId: {
      type: [Number, String],
      default: null
    },
    quantity: {
      type: Number,
      default: 1
    },
    message: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    variant() {
      return this.variantId || (this.product && this.product.master.id)
    }
  },
  methods: {
    onClick() {
      this.addToCartWithCheck({
        variantId: this.variant,
        quantity: this.quantity,
        message: this.message,
        onError: ({ info }) => {
          this.notify(null, {
            title: info.messages[0],
            message: info.messages[1],
            type: info.status
          })
        }
      })
    }
  }
}
